import { render, staticRenderFns } from "./faq_shssc.vue?vue&type=template&id=b81b9086&scoped=true"
import script from "./faq_shssc.vue?vue&type=script&lang=js"
export * from "./faq_shssc.vue?vue&type=script&lang=js"
import style0 from "./faq_shssc.vue?vue&type=style&index=0&id=b81b9086&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81b9086",
  null
  
)

export default component.exports